export const HTML_ENTITY = {
  NO_BREAK_SPACE: '\u00a0', // same as &nbsp;
  TIMES: '\u00D7', // same as &times;
  BLACK_CIRCLE: '\u25CF',
  CHECKMARK: '\u221A'
};
